<template>
  <div>
    <ul>
      <li v-for="item in list" :key="item.key"><a :href="item.location ? `/static/uploaded/${item.location}` : undefined" target="_blank">{{ item.fileName }}</a><i @click="remove(item)"></i></li>
    </ul>
    <label :class="{'dz-drag-hover':dragOver}" class="dropzone white dz-clickable"
           @dragover.prevent="onDragOver" @dragenter.prevent="onDragOver"
           @dragleave.prevent="onDragOut" @dragexit.prevent="onDragOut"
           @drop.prevent="onDrop">
      <span class="dz-message dz-clickable">
        <span class="mv-10 tc">
          <template v-if="dragSupport">+ 파일을 드래그해서 추가하시거나 영역을 클릭해서 선택하세요</template>
          <template v-else>클릭해서 파일을 선택하세요</template>
        </span>
      </span>
      <s class="input-holder"></s>
    </label>
    <div class="for-upload"></div>
    <input type="hidden" :name="name" v-model="already">
  </div>
</template>

<style lang="less" scoped>
  @import '../../less/asset';
  .has-danger .dropzone { border-color:#d9534f;  }
  .dropzone { position:relative; overflow: hidden; border: 1px dotted #666; margin-bottom: 0; padding:10px; .block; margin-top: 10px;
    span { display: block; }
    label { display: block; }
    s { position: absolute; top:-100px; }
  }
  ul { margin-top:10px; border:1px solid #eee; min-height: 20px; background: #e1fcff; padding:10px 10px 0 0; box-sizing: content-box;
    li { padding: 3px 30px 3px 10px; border:1px solid #fafafa; background: #fefefe; .ib; border-radius: 3px; margin-left:10px; margin-bottom:10px; .rel;
      i { .block; .wh(12px,100%); .rt(10px,0); .contain("/static/img/common/close_m.svg"); .no-repeat; .bg-p(center); .vam; cursor: pointer; }
    }
  }
  .for-upload { position: absolute; height:0; overflow: hidden;}
</style>

<script>
/* eslint-disable no-nested-ternary */

import _ from 'lodash';

export default {
  name: 'DropAttach',
  props: {
    org: { type: String, default: null },
    name: { type: String, default: null },
  },
  data() {
    return {
      list: [],
      dragSupport: false,
      dragOver: false,
      inputHolder: null,
      forUpload: null,
      removeFiles: [],
    };
  },
  mounted() {
    const el = this.$el;
    this.dragSupport = (('draggable' in el) || ('ondragstart' in el && 'ondrop' in el)) && 'FormData' in window && 'FileReader' in window;
    this.inputHolder = el.querySelector('.input-holder');
    this.forUpload = el.querySelector('.for-upload');
    this.makeInput();
    if (this.$props.org) {
      _.forEach(this.$props.org.split(','), (item) => {
        if (item) {
          this.list.push({
            key: `attach_${Math.floor(Math.random() * 1000000)}`,
            fileName: item.split('-').slice(2).join('-'),
            location: item,
            type: 'org',
          });
        }
      });
    }
  },
  computed: {
    already() {
      return _.reduce(this.list, (agg, item) => (item.type === 'org' ? (agg ? `${agg},${item.location}` : item.location) : agg), null);
    },
  },
  methods: {
    onDragOver() {
      this.dragOver = true;
    },
    onDragOut() {
      this.dragOver = false;
    },
    onDrop(e) {
      this.dragOver = false;
      const input = document.createElement('input');
      input.type = 'file';
      input.name = 'ATTACH_FILES';
      input.files = e.dataTransfer.files;
      this.addUpload(input);
    },
    fileSelected(e) {
      const input = e.currentTarget;
      this.addUpload(input);
      input.removeEventListener('change', this.fileSelected);
      this.makeInput();
    },
    addUpload(input) {
      this.forUpload.append(input);
      const fileNames = [];
      _.forEach(input.files, (file) => {
        fileNames.push(file.name);
      });
      this.list.push({
        name: input.name,
        type: 'upload',
        key: `attach_${Math.floor(Math.random() * 1000000)}`,
        fileName: fileNames.join(', '),
        input,
      });
    },
    reset() {
      this.list = [];
      this.removeFiles = [];
      this.forUpload.innerHTML = '';
      this.makeInput();
    },
    remove(item) {
      if (item.type === 'upload') {
        item.input.remove();
      } else {
        this.removeFiles.push(item.name);
      }
      this.list.splice(_.findIndex(this.list, item), 1);
    },
    makeInput() {
      this.inputHolder.innerHTML = '<input type="file" name="ATTACH_FILES" multiple>';
      const input = this.inputHolder.querySelector('input');
      input.addEventListener('change', this.fileSelected);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/DropAttach.vue